import { DAILY_TOKEN_GOAL } from "@/shared/config/constants";

// 色阶按日目标（1 亿）的绝对比例分五档，从透明到全黑，格子颜色的含义每天一致：
// 0 = 无上传；1–3 = 未达标的三档；4 = 达标（≥ 日目标）= 全黑，不另加标记。
const LEVEL_STEPS = [0.2, 0.5, 1];
export const GOAL_LEVEL = 4;

export function heatLevel(totalTokens, goal = DAILY_TOKEN_GOAL) {
  if (!totalTokens || totalTokens <= 0) return 0;
  const ratio = totalTokens / goal;
  if (ratio >= 1) return GOAL_LEVEL;
  return 1 + LEVEL_STEPS.findIndex((step) => ratio < step);
}

const DAY_MS = 24 * 60 * 60 * 1000;

// GitHub 式整条：列 = 周（周一起始），行 = 周一→周日。第一列从 1 月 1 日所在周的周一开始。
export function yearStartMonday(year) {
  const jan1 = Date.UTC(year, 0, 1);
  const offset = (new Date(jan1).getUTCDay() + 6) % 7;
  return jan1 - offset * DAY_MS;
}

export function buildHeatmapWeeks({ year, uploads = [], today, selectedDate = null, goal = DAILY_TOKEN_GOAL }) {
  const tokensByDate = new Map(uploads.map((item) => [item.date, item.totalTokens]));
  const start = yearStartMonday(year);
  const daysInYear = (Date.UTC(year + 1, 0, 1) - Date.UTC(year, 0, 1)) / DAY_MS;
  const weekCount = Math.ceil((Date.UTC(year, 0, 1) - start) / DAY_MS / 7 + daysInYear / 7);
  const prefix = `${year}-`;
  const columns = [];
  const monthLabels = [];
  for (let col = 0; col < weekCount; col++) {
    const days = [];
    for (let row = 0; row < 7; row++) {
      const date = new Date(start + (col * 7 + row) * DAY_MS).toISOString().slice(0, 10);
      if (!date.startsWith(prefix)) {
        days.push(null);
        continue;
      }
      if (date.endsWith("-01")) monthLabels.push({ col, label: `${Number(date.slice(5, 7))} 月` });
      const totalTokens = tokensByDate.get(date) ?? 0;
      const isFuture = date > today;
      days.push({
        date,
        totalTokens,
        level: isFuture ? 0 : heatLevel(totalTokens, goal),
        isFuture,
        isToday: date === today,
        isSelected: date === selectedDate,
      });
    }
    columns.push({ col, days });
  }
  return { columns, monthLabels };
}

export function heatmapStats(uploads, year, goal = DAILY_TOKEN_GOAL) {
  const inYear = uploads.filter((item) => item.date.startsWith(`${year}-`));
  return {
    uploadedDays: inYear.filter((item) => item.totalTokens > 0).length,
    goalDays: inYear.filter((item) => item.totalTokens >= goal).length,
  };
}
